import { BaseResponseDTO } from "./base.response.dto";
import { ParadaDTO } from "../parada.dto";

export class GetParadasViajeResponseDTO extends BaseResponseDTO {
  success: boolean;
  msg: string;
  data: ParadaDTO[];
}
